import type { CoreOfficeDataType } from '~/types/offices';
import { useLanguageParam } from '~/config/i18n';

const OfficeHeader = ({ office, mobileHeader = false }: { office: CoreOfficeDataType; mobileHeader?: boolean }) => {
  const lang = useLanguageParam();

  return (
    <div className={`${mobileHeader ? 'd-md-none mb-4' : 'd-none d-md-flex gap-8 justify-content-between mb-3'}`}>
      <div className="office-info-column flex-grow-1">
        {mobileHeader ? (
          <div className="fo-display-3 -medium">{office.title[lang]}</div>
        ) : (
          <h1 className="fo-display-3 -medium">{office.title[lang]}</h1>
        )}
      </div>
    </div>
  );
};

export default OfficeHeader;
